import FilterChip from 'components/Luxkit/Chips/FilterChip'
import ModalContext from 'contexts/ModalContext'
import { OfferPageFilterType } from 'contexts/OfferPage/offerPageStateReducer'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import React, { useCallback, useContext } from 'react'
import OfferCalendarAirportModal from './OfferCalendarAirportModal'

interface Props {
  airport?: App.Airport;
  activeFilter?: OfferPageFilterType;
}

function OfferCalendarAirportSelect(props: Props) {
  const { airport, activeFilter } = props

  const showModal = useContext(ModalContext)
  const open = activeFilter === 'airport'

  const onToggleOpen = useCallback(async() => {
    showModal<App.AirportLocation | undefined>(<OfferCalendarAirportModal />)
  }, [showModal])

  return <FilterChip
    size="medium"
    onClick={onToggleOpen}
    selected={open}
  >
    {airport ? `${airport.name} (${airport.code.toUpperCase()})` : 'Select by airport'}
  </FilterChip>
}

export default withOfferPageState(
  (state) => ({
    airport: state.airport,
    activeFilter: state.activeSubFilter,
  }))(OfferCalendarAirportSelect)
